import styled from "@emotion/styled";

export { LinkListItem } from "./LinkListItem";

export const List = styled("ul", {
  shouldForwardProp: (prop) => !["span", "withDoubledColumns"].includes(prop),
})<{
  withDoubledColumns?: boolean;
  span: number;
}>(({ theme, withDoubledColumns, span }) => ({
  listStyle: "none",
  padding: 0,
  margin: 0,
  display: "grid",
  gap: `${theme.spacing.LRG.xsml}px ${theme.spacing.LRG.sml}px`,
  gridColumnEnd: `span ${span}`,
  gridTemplateColumns: withDoubledColumns
    ? `repeat(${span * 2}, 1fr)`
    : `repeat(${span}, 1fr)`,
  [theme.breakpoints.nav.SML]: {
    gap: 0,
    gridTemplateColumns: "1fr",
    "> li": {
      borderBottom: `1px solid ${theme.colors.border.default}`,
      "&:first-of-type": {
        borderTop: `1px solid ${theme.colors.border.default}`,
      },
    },
  },
}));
